import { IAuth } from 'models/IAuth';
import { MessageFailAction } from 'store/global/types';

export enum AuthActionTypes {
  LOGOUT_SUCCESS = 'LOGOUT_SUCCESS',
  LOGIN_WITH_EMAIL_SUCCESS = 'LOGIN_WITH_EMAIL_SUCCESS',
  LOGIN_WITH_OAUTH_SUCCESS = 'LOGIN_WITH_OAUTH_SUCCESS',
  LOGIN_WITH_EMAIL_FAIL = 'LOGIN_WITH_EMAIL_FAIL',
  LOAD_PROFILE_SUCCESS = 'LOAD_PROFILE_SUCCESS'
}

interface LoadProfileSuccessAction {
  type: AuthActionTypes.LOAD_PROFILE_SUCCESS;
  payload: Pick<IAuth, 'me'>;
}

interface LoginWithEmailFailAction {
  type: AuthActionTypes.LOGIN_WITH_EMAIL_FAIL;
}

interface LoginWithEmailSuccessAction {
  type: AuthActionTypes.LOGIN_WITH_EMAIL_SUCCESS;
  payload: IAuth;
}
interface LoginWithOathSuccessAction {
  type: AuthActionTypes.LOGIN_WITH_OAUTH_SUCCESS;
  payload: IAuth;
}

interface LogoutSuccessAction {
  type: AuthActionTypes.LOGOUT_SUCCESS;
}


export type AuthActions =
  | LoadProfileSuccessAction
  | LoginWithEmailSuccessAction
  | LoginWithOathSuccessAction
  | LogoutSuccessAction
  | LoginWithEmailFailAction
  | MessageFailAction;
